export default __webpack_public_path__ + "static/media/scrum-sfpc.0703c064.png";